import { render, staticRenderFns } from "./CartItemLoading.vue?vue&type=template&id=60726716&scoped=true"
import script from "./CartItemLoading.vue?vue&type=script&lang=js"
export * from "./CartItemLoading.vue?vue&type=script&lang=js"
import style0 from "./CartItemLoading.vue?vue&type=style&index=0&id=60726716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60726716",
  null
  
)

export default component.exports